export interface CountryDropdownList{
    code: any
    text: any
}

export const CountryList: CountryDropdownList[] = [
    {"code": "AF", "text": "Afghanistan"},
    {"code": "AL", "text": "Albania"},
    {"code": "DZ", "text": "Algeria"},
    {"code": "AS", "text": "American Samoa"},
    {"code": "AD", "text": "Andorra"},
    {"code": "AO", "text": "Angola"},
    {"code": "AI", "text": "Anguilla"},
    {"code": "AG", "text": "Antigua and Barbuda"},
    {"code": "AR", "text": "Argentina"},
    {"code": "AM", "text": "Armenia"},
    {"code": "AW", "text": "Aruba"},
    {"code": "AU", "text": "Australia"},
    {"code": "AT", "text": "Austria"},
    {"code": "AZ", "text": "Azerbaijan"},
    {"code": "BS", "text": "Bahamas"},
    {"code": "BH", "text": "Bahrain"},
    {"code": "BD", "text": "Bangladesh"},
    {"code": "BB", "text": "Barbados"},
    {"code": "BY", "text": "Belarus"},
    {"code": "BE", "text": "Belgium"},
    {"code": "BZ", "text": "Belize"},
    {"code": "BJ", "text": "Benin"},
    {"code": "BT", "text": "Bhutan"},
    {"code": "BO", "text": "Bolivia"},
    {"code": "BA", "text": "Bosnia and Herzegovina"},
    {"code": "BW", "text": "Botswana"},
    {"code": "BR", "text": "Brazil"},
    {"code": "BN", "text": "Brunei"},
    {"code": "BG", "text": "Bulgaria"},
    {"code": "BF", "text": "Burkina Faso"},
    {"code": "BI", "text": "Burundi"},
    {"code": "CV", "text": "Cape Verde"},
    {"code": "KH", "text": "Cambodia"},
    {"code": "CM", "text": "Cameroon"},
    {"code": "CA", "text": "Canada"},
    {"code": "KY", "text": "Cayman Islands"},
    {"code": "CF", "text": "Central African Republic"},
    {"code": "TD", "text": "Chad"},
    {"code": "CL", "text": "Chile"},
    {"code": "CN", "text": "China"},
    {"code": "CO", "text": "Colombia"},
    {"code": "KM", "text": "Comoros"},
    {"code": "CG", "text": "Congo (Congo-Brazzaville)"},
    {"code": "CD", "text": "Congo (Congo-Kinshasa)"},
    {"code": "CK", "text": "Cook Islands"},
    {"code": "CR", "text": "Costa Rica"},
    {"code": "CI", "text": "Ivory Coast"},
    {"code": "HR", "text": "Croatia"},
    {"code": "CU", "text": "Cuba"},
    {"code": "CY", "text": "Cyprus"},
    {"code": "CZ", "text": "Czechia (Czech Republic)"},
    {"code": "DK", "text": "Denmark"},
    {"code": "DJ", "text": "Djibouti"},
    {"code": "DM", "text": "Dominica"},
    {"code": "DO", "text": "Dominican Republic"},
    {"code": "EC", "text": "Ecuador"},
    {"code": "EG", "text": "Egypt"},
    {"code": "SV", "text": "El Salvador"},
    {"code": "GQ", "text": "Equatorial Guinea"},
    {"code": "ER", "text": "Eritrea"},
    {"code": "EE", "text": "Estonia"},
    {"code": "SZ", "text": "Eswatini (fmr. Swaziland)"},
    {"code": "ET", "text": "Ethiopia"},
    {"code": "FI", "text": "Finland"},
    {"code": "FR", "text": "France"},
    {"code": "GA", "text": "Gabon"},
    {"code": "GM", "text": "Gambia"},
    {"code": "GE", "text": "Georgia"},
    {"code": "DE", "text": "Germany"},
    {"code": "GH", "text": "Ghana"},
    {"code": "GR", "text": "Greece"},
    {"code": "GD", "text": "Grenada"},
    {"code": "GT", "text": "Guatemala"},
    {"code": "GN", "text": "Guinea"},
    {"code": "GW", "text": "Guinea-Bissau"},
    {"code": "GY", "text": "Guyana"},
    {"code": "HT", "text": "Haiti"},
    {"code": "HN", "text": "Honduras"},
    {"code": "HK", "text": "Hong Kong"},
    {"code": "HU", "text": "Hungary"},
    {"code": "IS", "text": "Iceland"},
    {"code": "IN", "text": "India"},
    {"code": "ID", "text": "Indonesia"},
    {"code": "IR", "text": "Iran"},
    {"code": "IQ", "text": "Iraq"},
    {"code": "IE", "text": "Ireland"},
    {"code": "IL", "text": "Israel"},
    {"code": "IT", "text": "Italy"},
    {"code": "JM", "text": "Jamaica"},
    {"code": "JP", "text": "Japan"},
    {"code": "JO", "text": "Jordan"},
    {"code": "KZ", "text": "Kazakhstan"},
    {"code": "KE", "text": "Kenya"},
    {"code": "KI", "text": "Kiribati"},
    {"code": "KP", "text": "North Korea"},
    {"code": "KR", "text": "South Korea"},
    {"code": "KW", "text": "Kuwait"},
    {"code": "KG", "text": "Kyrgyzstan"},
    {"code": "LA", "text": "Laos"},
    {"code": "LV", "text": "Latvia"},
    {"code": "LB", "text": "Lebanon"},
    {"code": "LS", "text": "Lesotho"},
    {"code": "LR", "text": "Liberia"},
    {"code": "LY", "text": "Libya"},
    {"code": "LI", "text": "Liechtenstein"},
    {"code": "LT", "text": "Lithuania"},
    {"code": "LU", "text": "Luxembourg"},
    {"code": "MO", "text": "Macau"},
    {"code": "MK", "text": "North Macedonia"},
    {"code": "MG", "text": "Madagascar"},
    {"code": "MW", "text": "Malawi"},
    {"code": "MY", "text": "Malaysia"},
    {"code": "MV", "text": "Maldives"},
    {"code": "ML", "text": "Mali"},
    {"code": "MT", "text": "Malta"},
    {"code": "MH", "text": "Marshall Islands"},
    {"code": "MQ", "text": "Martinique"},
    {"code": "MR", "text": "Mauritania"},
    {"code": "MU", "text": "Mauritius"},
    {"code": "YT", "text": "Mayotte"},
    {"code": "MX", "text": "Mexico"},
    {"code": "FM", "text": "Micronesia"},
    {"code": "MD", "text": "Moldova"},
    {"code": "MC", "text": "Monaco"},
    {"code": "MN", "text": "Mongolia"},
    {"code": "ME", "text": "Montenegro"},
    {"code": "MS", "text": "Montserrat"},
    {"code": "MA", "text": "Morocco"},
    {"code": "MZ", "text": "Mozambique"},
    {"code": "MM", "text": "Myanmar (Burma)"},
    {"code": "NA", "text": "Namibia"},
    {"code": "NR", "text": "Nauru"},
    {"code": "NP", "text": "Nepal"},
    {"code": "NL", "text": "Netherlands"},
    {"code": "NC", "text": "New Caledonia"},
    {"code": "NZ", "text": "New Zealand"},
    {"code": "NI", "text": "Nicaragua"},
    {"code": "NE", "text": "Niger"},
    {"code": "NG", "text": "Nigeria"},
    {"code": "NU", "text": "Niue"},
    {"code": "NF", "text": "Norfolk Island"},
    {"code": "NO", "text": "Norway"},
    {"code": "OM", "text": "Oman"},
    {"code": "PK", "text": "Pakistan"},
    {"code": "PW", "text": "Palau"},
    {"code": "PS", "text": "Palestine"},
    {"code": "PA", "text": "Panama"},
    {"code": "PG", "text": "Papua New Guinea"},
    {"code": "PY", "text": "Paraguay"},
    {"code": "PE", "text": "Peru"},
    {"code": "PH", "text": "Philippines"},
    {"code": "PN", "text": "Pitcairn Islands"},
    {"code": "PL", "text": "Poland"},
    {"code": "PT", "text": "Portugal"},
    {"code": "PR", "text": "Puerto Rico"},
    {"code": "QA", "text": "Qatar"},
    {"code": "RE", "text": "Reunion"},
    {"code": "RO", "text": "Romania"},
    {"code": "RU", "text": "Russia"},
    {"code": "RW", "text": "Rwanda"},
    {"code": "BL", "text": "Saint Barthelemy"},
    {"code": "SH", "text": "Saint Helena"},
    {"code": "KN", "text": "Saint Kitts and Nevis"},
    {"code": "LC", "text": "Saint Lucia"},
    {"code": "MF", "text": "Saint Martin"},
    {"code": "PM", "text": "Saint Pierre and Miquelon"},
    {"code": "VC", "text": "Saint Vincent and the Grenadines"},
    {"code": "WS", "text": "Samoa"},
    {"code": "SM", "text": "San Marino"},
    {"code": "ST", "text": "Sao Tome and Principe"},
    {"code": "SA", "text": "Saudi Arabia"},
    {"code": "SN", "text": "Senegal"},
    {"code": "RS", "text": "Serbia"},
    {"code": "SC", "text": "Seychelles"},
    {"code": "SL", "text": "Sierra Leone"},
    {"code": "SG", "text": "Singapore"},
    {"code": "SX", "text": "Sint Maarten"},
    {"code": "SK", "text": "Slovakia"},
    {"code": "SI", "text": "Slovenia"},
    {"code": "SB", "text": "Solomon Islands"},
    {"code": "SO", "text": "Somalia"},
    {"code": "ZA", "text": "South Africa"},
    {"code": "GS", "text": "South Georgia and the South Sandwich Islands"},
    {"code": "ES", "text": "Spain"},
    {"code": "LK", "text": "Sri Lanka"},
    {"code": "SD", "text": "Sudan"},
    {"code": "SR", "text": "Suriname"},
    {"code": "SJ", "text": "Svalbard and Jan Mayen"},
    {"code": "SE", "text": "Sweden"},
    {"code": "CH", "text": "Switzerland"},
    {"code": "SY", "text": "Syria"},
    {"code": "TW", "text": "Taiwan"},
    {"code": "TJ", "text": "Tajikistan"},
    {"code": "TZ", "text": "Tanzania"},
    {"code": "TH", "text": "Thailand"},
    {"code": "TL", "text": "Timor-Leste"},
    {"code": "TG", "text": "Togo"},
    {"code": "TK", "text": "Tokelau"},
    {"code": "TO", "text": "Tonga"},
    {"code": "TT", "text": "Trinidad and Tobago"},
    {"code": "TN", "text": "Tunisia"},
    {"code": "TR", "text": "Turkey"},
    {"code": "TM", "text": "Turkmenistan"},
    {"code": "TC", "text": "Turks and Caicos Islands"},
    {"code": "TV", "text": "Tuvalu"},
    {"code": "UG", "text": "Uganda"},
    {"code": "UA", "text": "Ukraine"},
    {"code": "AE", "text": "United Arab Emirates"},
    {"code": "GB", "text": "United Kingdom"},
    {"code": "US", "text": "United States"},
    {"code": "UY", "text": "Uruguay"},
    {"code": "UZ", "text": "Uzbekistan"},
    {"code": "VU", "text": "Vanuatu"},
    {"code": "VA", "text": "Vatican City"},
    {"code": "VE", "text": "Venezuela"},
    {"code": "VN", "text": "Vietnam"},
    {"code": "WF", "text": "Wallis and Futuna"},
    {"code": "YE", "text": "Yemen"},
    {"code": "ZM", "text": "Zambia"},
    {"code": "ZW", "text": "Zimbabwe"}
]
